export const SwanIncomingPaymentsUrl = `/swanIncomingPayments`;

export const SwanIncomingPaymentUrlSwanIncomingPaymentIdParam = 'swanIncomingPaymentId';
export const SwanIncomingPaymentUrlMapping = `${SwanIncomingPaymentsUrl}/:${SwanIncomingPaymentUrlSwanIncomingPaymentIdParam}`;
export const swanIncomingPaymentUrl = (swanIncomingPaymentId: string) => `${SwanIncomingPaymentsUrl}/${swanIncomingPaymentId}`;